import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { COPY } from "@/data/copy";

const LanguageContext = createContext(null);

const initialLang = () => {
  const urlLang = new URLSearchParams(window.location.search).get("lang");
  if (urlLang === "en" || urlLang === "es") return urlLang;
  const saved = localStorage.getItem("rh-lang");
  if (saved === "en" || saved === "es") return saved;
  return navigator.language && navigator.language.toLowerCase().startsWith("es") ? "es" : "en";
};

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    const { seo } = COPY[lang];
    localStorage.setItem("rh-lang", lang);
    document.documentElement.lang = lang;
    document.title = seo.title;
    setMeta('meta[name="description"]', "content", seo.description);
    setMeta('meta[name="keywords"]', "content", seo.keywords);
    setMeta('meta[property="og:title"]', "content", seo.title);
    setMeta('meta[property="og:description"]', "content", seo.description);
    setMeta('meta[property="og:locale"]', "content", seo.locale);
    setMeta('meta[name="twitter:title"]', "content", seo.title);
    setMeta('meta[name="twitter:description"]', "content", seo.description);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle: () => setLang((l) => (l === "en" ? "es" : "en")),
      t: COPY[lang],
      tr: (obj, key) => (lang === "es" && obj[`${key}Es`] ? obj[`${key}Es`] : obj[key]),
      town: (name) => COPY[lang].towns[name] || name,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
